import {
  AddressDetails,
  DeliveryType,
  ServiceTime
} from 'components/common/types'
import {
  CART_ORDER_SUCCESS,
  SET_SERVICE_ADDRESS_DETAILS,
  SET_SERVICE_DELIVERY_TYPE,
  SET_SERVICE_TIME_DETAILS
} from 'constants/actionTypes'

type IServiceDeliveryOptions = {
  deliveryType: DeliveryType
  destinationAddress: AddressDetails
  serviceTime: ServiceTime
  deliveryDate: string
}

const initialState = {
  deliveryType: DeliveryType.DELIVER,
  serviceTime: ServiceTime.ASAP,
  deliveryDate: '',
  destinationAddress: {
    town: '',
    parish: '',
    parishTown: '',
    island: '',
    googleResponse: undefined,
    address: '',
    deliveryPlace: '',
    filteredParishes: [],
    streetDetails: '',
    latitude: undefined,
    longitude: undefined
  }
}

const ServiceDeliveryOptionsReducer = (
  state: IServiceDeliveryOptions = initialState,
  action
): IServiceDeliveryOptions => {
  switch (action.type) {
    case SET_SERVICE_TIME_DETAILS:
      return {
        ...state,
        serviceTime: action.payload.serviceTime,
        deliveryDate: action.payload.deliveryDate
      }

    case SET_SERVICE_DELIVERY_TYPE:
      return {
        ...state,
        deliveryType: action.payload
      }

    case CART_ORDER_SUCCESS:
      return {
        ...state,
        deliveryDate: '',
        deliveryType: DeliveryType.DELIVER,
        serviceTime: ServiceTime.ASAP
      }

    case SET_SERVICE_ADDRESS_DETAILS:
      return {
        ...state,
        destinationAddress: action.payload
      }

    default:
      return state
  }
}

export default ServiceDeliveryOptionsReducer
